// stores/company.js
import { defineStore } from 'pinia';

export const useCompanyStore = defineStore('company', {
  state: () => ({
    tempCompany: null
  }),
  actions: {
    setTempCompany(company) {
      this.tempCompany = company;
    },
    clearTempCompany() {
      this.tempCompany = null;
    }
  }
});